import { render, staticRenderFns } from "./ExchangeUsage.vue?vue&type=template&id=e557b508&"
import script from "./ExchangeUsage.vue?vue&type=script&lang=js&"
export * from "./ExchangeUsage.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeUsage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports